<div class="flex-container gap-16" style="height: 100%">
  <vl-widget-title [text]="'dashboard_ui.ca_cumule' | trans" [accent]="totalDisplay" [widget]="widget()" [draggable]="true" [filter]="true" [info]="'dashboard_ui.ca_cumule_info' | trans">
    <ng-content class="drag-handler" select='.drag-handler'></ng-content>
    <vl-widget-period-filters class="filter" [(period)]="period" [(timeScale)]="timeScale"/>
  </vl-widget-title>

  @if (metadata().loading) {
    <div class="h100 overflow-hidden">
      <ngx-skeleton-loader count="1"
                           [theme]="{'height': '200px', 'background-color': 'var(--color-on-disabled)', 'clip-path':'polygon(45% 69%, 64% 45%, 83% 57%, 100% 14%, 100% 100%, 0 100%, 0 90%, 23% 60%)'}"/>
    </div>
  } @else if (data()?.data?.length) {
    <div class="h100 fade-in chart-area">
      <canvas #cacumule></canvas>
      <vl-chips class="see-all-chip"
                state="active"
                size="small"
                iconRight="open_in_new"
                (action)="openFullList()"
                matTooltip="Détail du CA cumulé période par période avec top clients et export Excel">
        {{ 'button.see_all' | trans }}
      </vl-chips>
    </div>
  } @else {
    <span class="caption on-disabled">{{ 'list.empty' | trans }}</span>
  }
</div>
